import { personEntry } from '../components/Views/Helpers/AuthorsLink';
import { vocabTitle } from './content';

/**
 * The speakers of a talk, each once: the linked profiles with their degree,
 * then the `speaker` text, which is meant for speakers without a profile.
 *
 * Returns entries of {key, name, href}; href is null for the text and for
 * a profile whose page is not linkable.
 */
export const talkSpeakers = (talk) => {
  const profiles = Array.isArray(talk?.related_speakers)
    ? talk.related_speakers.filter(Boolean)
    : [];
  const entries = profiles.map((person, index) => {
    const entry = personEntry(person, index, true);
    const degree = vocabTitle(person.type_of_degree);
    return { ...entry, name: [degree, entry.name].filter(Boolean).join(' ') };
  });
  if (talk?.speaker) {
    entries.push({ key: 'speaker', name: talk.speaker, href: null });
  }
  return entries;
};

export default talkSpeakers;
